import { Icone } from './Icone';

const ANEL_R = 11;
const ANEL_CIRC = 2 * Math.PI * ANEL_R;

interface Props {
  forma: 'barra' | 'anel';
  valor: number;
  max: number;
  tom?: string;
  rotulo?: string;
  title?: string;
  icone?: string;
  /** "%": o número sai como porcentagem ("37%"), sem o "/ máx" na barra. */
  unidade?: string;
}

export function Medidor({ forma, valor, max, tom = 'fadiga', rotulo, title, icone, unidade }: Props) {
  const v = Math.max(0, Math.min(max, valor));
  const frac = max > 0 ? v / max : 0;
  if (forma === 'anel') {
    const offset = ANEL_CIRC * (1 - frac);
    return (
      <span
        className={`kit-anel kit-anel--${tom}`}
        role="meter"
        aria-label={rotulo}
        aria-valuenow={Math.round(v)}
        aria-valuemin={0}
        aria-valuemax={max}
        title={title}
      >
        <span className="kit-anel__aro">
          <svg viewBox="0 0 26 26" aria-hidden="true">
            <circle cx="13" cy="13" r={ANEL_R} fill="none" stroke="rgba(0,0,0,.55)" strokeWidth="2.6" />
            <circle
              cx="13"
              cy="13"
              r={ANEL_R}
              fill="none"
              stroke="currentColor"
              strokeWidth="2.6"
              strokeLinecap="round"
              strokeDasharray={ANEL_CIRC.toFixed(3)}
              strokeDashoffset={offset.toFixed(3)}
              transform="rotate(-90 13 13)"
            />
          </svg>
          {icone && (
            <span className="kit-anel__glifo">
              <Icone nome={icone} tam={13} />
            </span>
          )}
        </span>
        <span className="kit-anel__n">{Math.round(v).toLocaleString('pt-BR')}{unidade}</span>
      </span>
    );
  }
  const pct = frac * 100;
  return (
    <div
      className="kit-bar"
      role="meter"
      aria-label={rotulo}
      aria-valuenow={Math.round(v)}
      aria-valuemin={0}
      aria-valuemax={max}
      title={title}
    >
      {rotulo && <span className="kit-bar__k">{rotulo}</span>}
      <span className="kit-bar__trilho">
        <span className={`kit-bar__fill bar__fill--${tom}`} style={{ width: `${pct}%` }} />
      </span>
      <span className="kit-bar__n">
        {Math.round(v).toLocaleString('pt-BR')}{unidade ?? ` / ${max.toLocaleString('pt-BR')}`}
      </span>
    </div>
  );
}
